import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  BrowserRouter as Router, 
  Route, 
  Routes,
  Navigate,
  useLocation
} from 'react-router-dom';
import './App.scss';
import { fetchFunds } from './api/funds';
import { fetchCampaigns } from './api/campaigns';
import { setFunds, setCampaigns } from './store/slices/donation';
import { AdminProvider } from './contexts/AdminContext';
import CustomSpinner from './components/CustomSpinner';
import Home from './pages/Home';
import Donation from './pages/Donation';
import ManageDonation from './pages/ManageDonation';
import AdminPanel from './pages/AdminPanel';
import Navbar from './components/Navbar';
import './i18n';

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFundsAndCampaigns = async () => {
      const funds = await fetchFunds();
      const campaigns = await fetchCampaigns();
      dispatch(setFunds(funds.filter((fund) => fund.showOnWebsite)));
      dispatch(setCampaigns(campaigns));
      setLoading(false);
    };

    loadFundsAndCampaigns();
  }, [dispatch]);

  if (loading) {
    return (
      <div className='app-loading-container'>
        <CustomSpinner />
      </div>
    );
  }
  return (
    <AdminProvider>
      <Router>
        <ThemeWrapper>
          <Navbar />
          <Routes>
            <Route 
              path="/" 
              element={<Navigate to="/donate?template=Fridays" replace />} 
            />
            <Route 
              path="/home" 
              element={<Home />} 
            />
            <Route 
              path="/donate" 
              element={<Donation />} 
            />          <Route 
              path="/manage-donation/:scheduleId" 
              element={<ManageDonation />} 
            />
            <Route 
              path="/admin"
              element={<AdminPanel />}
            />
          </Routes>
        </ThemeWrapper>
      </Router>
    </AdminProvider>
  );
}

function ThemeWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const template = searchParams.get('template');

    document.body.classList.remove('theme-rajab');
    document.body.classList.remove('theme-fridays');
    document.body.classList.remove('theme-hijri');
    document.body.classList.remove('theme-lunar');

    if (template) {
      if (template === 'Rajab') {
        document.body.classList.add('theme-rajab');
      } else if (template === 'Fridays') {
        document.body.classList.add('theme-fridays');
      } else if (template.toLowerCase().includes('hijri')) {
        document.body.classList.add('theme-hijri');
      } else if (template.toLowerCase().includes('lunar')) {
        document.body.classList.add('theme-lunar');
      } else {
        document.body.classList.add('theme-lunar');
      }
    } else {
      document.body.classList.add('theme-lunar');
    }
  }, [location.search]);

  return children;
}

export default App;
